import Vue from 'vue'
import Router from 'vue-router'

import Request from "@/components/Request";
import Dashboard from "@/components/Dashboard";
import Loans from "@/components/Loans";
import Login from "@/components/Login";
import ViewRequest from "@/components/ViewRequest";
import Profile from "@/components/Profile";
import Loan from "@/components/Loan";
import Notifications from "@/components/Notifications";
import Requests from "@/components/Requests";
import Password from "@/components/Password";
import Recover from "@/components/Recover";
import Verify from "@/components/Verify";
import ViewLoan from "@/components/ViewLoan";
import Leave from "@/components/Leave";
import Staff from "./components/Staff";
import Refund from "./components/Refund";
import RequestBudgeting from "@/components/RequestBudgeting.vue";
import Procure from "@/components/procurement/Procure.vue";
// import Vendors from "@/components/procurement/Vendors.vue";
import Procurement from "@/components/procurement/Procurement.vue";
import Procurements from "@/components/procurement/Procurements.vue";

import CreditCard from "@/components/CreditCard.vue";
import FileUpload from "@/components/FileUpload.vue";
import Error500 from "@/components/errors/Error500.vue";
import PreCreateRequest from "@/components/PreCreateRequest.vue";


Vue.use(Router)

let routes = [
    {path: '/', redirect: '/home'},
    {path: '/login', component: Login, meta: {auth: false, title: 'Login'}},
    {path: '/recover', component: Recover, meta: {auth: false, title: 'Recover Password'}},
    {path: '/verify', component: Verify, meta: {auth: false, title: 'Verification Code'}},

    {path: '/home', component: Dashboard, meta: {auth: true, title: 'Dashboard'}},
    {path: '/requests/precreate', component: PreCreateRequest, meta: {auth: true, title: 'Request Creation Method'}},
    {path: '/requests/create/:code?', component: Request, props: true, meta: {auth: true, title: 'Create Request'}},
    {path: '/requests', component: Requests, meta: {auth: true, title: 'My Requests'}},
    {
        path: '/requests/budgeting/:code?',
        component: RequestBudgeting,
        props: true,
        meta: {auth: true, title: 'Requests Budgeting'}
    },
    {
        path: '/requests/card/:code?',
        component: CreditCard,
        props: true,
        meta: {auth: true, title: 'Credit Card Budgeting'}
    },
    {path: '/requests/:code', component: ViewRequest, meta: {auth: true, title: 'View Request'}, props: true},
    {path: '/requests/:code/documents', component: FileUpload, meta: {auth: true, title: 'Request Documents'}, props: true},
    {path: '/requests/:code/refund', component: Refund, meta: {auth: true, title: 'Create Refund'}, props: true},

    {path: '/loans', component: Loans, meta: {auth: true, title: 'Loans'}},
    {path: '/loans/request', component: Loan, meta: {auth: true, title: 'Request Loan'}},
    {path: '/loans/:id', component: ViewLoan, props: true, meta: {auth: true, title: 'View Loan'}},

    {path: '/profile', component: Profile, meta: {auth: true, title: 'My Profile'}},
    {path: '/profile/password', component: Password, meta: {auth: true, title: 'Change Your Password'}},
    {path: '/notifications', component: Notifications, meta: {auth: true, title: 'My Notifications'}},

    {path: '/procurements', component: Procurements, meta: {auth: true, title: 'Procurements'}},
    {path: '/procurements/create', component: Procure, meta: {auth: true, title: 'Procurement Form'}},
    {path: '/procurements/view/:id?', component: Procurement, meta: {auth: true, title: 'View Procurement'}},

    {path: '/leave', component: Leave, meta: {auth: true, title: 'Leave Days'}},
    {path: '/staff/:id', component: Staff, props: true, meta: {auth: true, title: 'Staff Profile'}},

    {path: '/error', component: Error500, meta: {title: 'Internal Server Error'}},
]

const router = new Router({
    mode: 'history',
    routes,
    linkActiveClass: "active",
    linkExactActiveClass: "active"
})

export default router